import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InputPortal from '@/components/edit/InputPortal/index.vue'
import Control from '@/helpers/control'
import api from '@/helpers/fetch'
import BadgeAprovado from '@/components/edit/BadgeAprovado/index.vue'
import BadgeNaoAprovado from '@/components/edit/BadgeNaoAprovado/index.vue'
import BadgePendente from '@/components/edit/BadgePendente/index.vue'
import vSelect from 'vue-select'
import DropdownStatusEmail from '@/components/edit/DropdownStatusEmail/index.vue'
import SimpleSelectPortal from '@/components/edit/SimpleSelectPortal/index.vue'
import FieldDatePortal from '@/components/edit/FieldDatePortal/index.vue'
import dateHelper from '@/helpers/date'
import Loader from '@/components/Loader/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHourglassHalf } from '@fortawesome/free-solid-svg-icons'

import emailsHelper from '@/helpers/emails'

import VueTrix from 'vue-trix'

library.add(faHourglassHalf)

@Component({
	components: {
		BadgeAprovado,
		BadgeNaoAprovado,
		BadgePendente,
		InputPortal,
		VueTrix,
		vSelect,
		DropdownStatusEmail,
		SimpleSelectPortal,
		FieldDatePortal,
		Loader,
	},
})
export default class EmailLog extends Vue {
	@Prop() readonly email
	@Prop() readonly index
	@Prop() readonly signatureTemplate
	@Prop({ default: false }) isAdm

	emailLocal

	alertVariant = {
		nao_aprovado: {
			variant: 'danger',
		},
		pendente: {
			variant: 'warning',
		},
		aprovado: {
			variant: 'success',
		},
	}

	get reviewerName() {
		if (this.email.is_adm) {
			return this.email?.group?.groupsAdm[0]?.reviewer?.name || ''
		} else {
			return this.email?.group?.reviewer?.name || ''
		}
	}

	get elaboratorName() {
		if (this.email.is_adm) {
			return this.email?.group?.groupsAdm[0]?.elaborator?.name || ''
		} else {
			return this.email?.group?.elaborator?.name || ''
		}
	}

	statusComponents = emailsHelper.statusComponents()
	contentNoSignature = ''
	async mounted() {
		this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
			if (isJustShown) {
				this.emailLocal = this.email
			} else {
				this.emailLocal = null
			}

			this.initiate()
		})
	}

	initiate() {
		if (this.emailLocal) {
			if (this.hasSpecific()) {
				this.getReportFiles()
			}

			const pattern =
				'Segue o relatório dos andamentos processuais relativo ao mês de'
			const semesterBeginning =
				'Encerramos mais um período e apresentamos o nosso relatório com os andamentos processuais com seus casos.'

			if (this.emailLocal.content.includes(pattern)) {
				this.activeTemplateType = 'pattern'
			} else if (this.email.content.includes(semesterBeginning)) {
				this.activeTemplateType = 'semesterBeginning'
			} else {
				this.activeTemplateType = null
			}

			this.contentNoSignature = removeSignature(this.emailLocal.content)
		}
	}

	reportFiles: any[] = []
	selectedReportFiles: any[] = []
	async getReportFiles() {
		const type = this.isAdm ? 'Administrativo' : 'Judicial'

		const res = await api.get(
			`/api/reports/${this.emailLocal.group.id}/${type}`,
		)
		this.reportFiles = res.reportFiles

		if (this.hasPortal()) {
			const path = this.isAdm
				? `/api/relatorio-adm/${this.emailLocal.group.id}`
				: `/api/relatorio/${this.emailLocal.group.id}`
			this.reportFiles.unshift({ name: 'Portal', path })
		}
		/*
		const reportFilesByPath = {}
		if (this.reportFiles && this.reportFiles.length) {
			this.reportFiles.forEach((file: any) => {
				reportFilesByPath[file.path] = file
			})
		}

		if (this.emailLocal.attachments && this.emailLocal.attachments.length) {
			this.selectedReportFiles = []
			this.emailLocal.attachments.forEach((path) => {
				if (reportFilesByPath[path]) {
					this.selectedReportFiles.push(reportFilesByPath[path])
				}
			})
		}
		console.log('reportFiles: ', this.reportFiles)
		console.log('email.attachments: ', this.email.attachments)
		*/
	}

	getIndex(index1, index2) {
		return 'collapse-' + index1 + '-' + index2
	}

	makeString(array) {
		if (array && array.length) {
			return array.join(', ')
		}
	}

	expanded = false
	seeMore() {
		this.expanded = true
	}

	control = new Control()
	state: any = {}
	key = 0

	async onInputSubject(newSubject) {
		const debouncedChange = this.control.debounce(this.save, 500)
		const res = await debouncedChange(
			{ id: this.emailLocal.id, subject: newSubject },
			'subject',
		)
	}

	async save(emailLog, stateName) {
		const value = emailLog[stateName]
		Vue.set(this.emailLocal, stateName, value)
		this.state[stateName] = 'loading'
		this.key++
		const resp = await this.$store.dispatch('fetchSaveEmailLogs', emailLog)

		if (resp.ok) {
			this.state[stateName] = 'valid'
			if (stateName === 'send_at') {
				window.location.reload()
			}
		} else {
			this.state[stateName] = 'error'
		}
		this.key++
	}

	activeTemplateType: string | null = null
	vueTrixUpdateKey = 0
	async changeTemplate(type) {
		this.activeTemplateType = type
		let content
		// eslint-disable-next-line camelcase
		const sendAt = this.emailLocal?.send_at
		const fromName = this.emailLocal?.group?.reportSendingFrom?.name

		if (type === 'semesterBeginning') {
			content = getMessageSemesterBeggining(null, fromName)
		} else if (type === 'pattern') {
			content = getMessage(getMonthString(sendAt), fromName)
		} else if (type === null) {
			content = '<br/><br/>' + getSignaturePlaceholder()
		}

		Vue.set(this, 'contentNoSignature', content)
	}

	@Watch('contentNoSignature')
	async onStateChange(newValue, oldValue) {
		if (oldValue !== undefined) {
			const signaturePlaceholder = getSignaturePlaceholder()
			let contentWithSignature = newValue

			// if (!contentWithSignature.includes(signaturePlaceholder)) {
			// 	contentWithSignature += signaturePlaceholder
			// }

			const fromName = this.emailLocal?.group?.reportSendingFrom?.name
			const fromEmail = this.emailLocal?.group?.reportSendingFrom?.email

			const position =
				fromEmail === 'daniel.avila@locatelliadv.com.br'
					? 'Sócio'
					: 'Advogado(a)'

			const signature = getSignature(
				fromName,
				position,
				fromEmail,
				this.signatureTemplate,
			)

			const regex = /\[\[\[ASSINATURA\]\]\]/
			contentWithSignature = contentWithSignature.replace(
				regex,
				signature,
			)
			const debouncedChange = this.control.debounce(this.save, 500)
			debouncedChange(
				{ id: this.emailLocal.id, content: contentWithSignature },
				'content',
			)
		}
	}

	onReportFilesInput(selected) {
		const attachments = [selected]

		const debouncedChange = this.control.debounce(this.save, 500)
		debouncedChange({ id: this.email.id, attachments }, 'attachments')
	}

	format(date) {
		return dateHelper.utc.format(date)
	}

	async onClosedInput(value) {
		this.save(
			{
				id: this.emailLocal.id,
				closed: value,
			},
			'closed',
		)
	}

	keySendAt = 0
	async onSendAtInput(name, value) {
		const newSendAt = `${value}T17:00:00.001-03:00`
		const saveSendAt = new Date(newSendAt)
			.toISOString()
			.replace('Z', '+00:00')

		this.keySendAt++

		await this.save(
			{
				id: this.emailLocal.id,
				send_at: saveSendAt,
			},
			'send_at',
		)

		this.keySendAt++
	}

	loadingSend = false
	async resendEmailNow(emailLog) {
		if (!this.loadingSend) {
			this.loadingSend = true
			await this.$store.dispatch('fetchSendEmailNow', emailLog)
			this.loadingSend = false
		}
	}

	loadingStatus = false
	async onStatusChange(email, isAdm) {
		const toastConfig = {
			title: 'Erro!',
			variant: 'danger',
			solid: true,
			toaster: 'b-toaster-top-center',
		}
		if (email.status === 'aprovado') {
			const group = isAdm
				? this.email.group.groupsAdm[0]
				: this.email.group

			// sem remetente
			if (!group.reportSendingFrom || !group.reportSendingFrom.email) {
				this.$bvToast.toast(
					'Não é possível aprovar um email sem remetente (Advogado)',
					toastConfig,
				)
				return
			}

			// sem destinatario
			if (!group.reportSendingTo || group.reportSendingTo.length < 1) {
				this.$bvToast.toast(
					'Não é possível aprovar um email sem destinatário',
					toastConfig,
				)
				return
			}

			// sem anexo
			if (
				group.reportType === 'Específico' &&
				this.selectedReportFiles.length < 1
			) {
				this.$bvToast.toast(
					'Não é possível aprovar um email sem anexo',
					toastConfig,
				)
				return
			}
		}

		this.loadingStatus = true

		const action = isAdm ? 'fetchSaveEmailLogsAdm' : 'fetchSaveEmailLogs'
		const resp = await this.$store.dispatch(action, email)

		if (resp?.ok) {
			Vue.set(this.email, 'status', email.status)
		} else {
			this.$bvToast.toast(resp?.msg, toastConfig)
		}
		this.loadingStatus = false
	}

	componentIs() {
		return (
			this.statusComponents &&
			this.statusComponents[this.email.status] &&
			this.statusComponents[this.email.status].component
		)
	}

	formatDateAndTime(val: number) {
		return dateHelper.userTimezone.formatDateAndTime(val)
	}

	hasPortal() {
		const group = this.isAdm
			? this.email.group.groupsAdm[0]
			: this.email.group

		return group.reportType.find((item) => item === 'Portal')
	}

	hasSpecific() {
		const group = this.isAdm
			? this.email.group.groupsAdm[0]
			: this.email.group

		return group.reportType.find((item) => item === 'Específico')
	}
}

function getMonthString(date) {
	const d = new Date(date)
	const mo = d.getMonth()
	const monthStrings = [
		'Janeiro',
		'Fevereiro',
		'Março',
		'Abril',
		'Maio',
		'Junho',
		'Julho',
		'Agosto',
		'Setembro',
		'Outubro',
		'Novembro',
		'Dezembro',
	]

	return monthStrings[mo]
}

function getMessage(monthString, fromName) {
	const outputName = fromName || 'Locatelli Advogados'

	const defaultParagraph = `<p>Prezado(s),<br />
    <br />Segue o relatório dos andamentos processuais relativo ao mês de ${monthString}.<br />

    <br />Eventuais dúvidas poderão ser encaminhadas para mim e para o email <a href="mailto:relatorio@locatelliadv.com.br">relatorio@locatelliadv.com.br</a>.<br />
    <br />Ao tomar ciência de qualquer decisão pelo Domicílio Judicial Eletrônico em processos judiciais patrocinados pelo Locatelli, favor encaminhar as decisões para: intimacoes@locatelliadv.com.br.<br />
    <br />Por fim, havendo solicitação de resposta de carta de auditoria, pedimos que seja encaminhada diretamente para o seguinte email: <a href="mailto:cartadecircularizacao@locatelliadv.com.br">cartadecircularizacao@locatelliadv.com.br</a>.

    <br />Abs,<br />
    ${outputName}.</p>`

	return `${defaultParagraph}<br />${getSignaturePlaceholder()}`
}

function getMessageSemesterBeggining(monthString, fromName) {
	const outputName = fromName || 'Locatelli Advogados'

	const defaultParagraph = `<p>Caro cliente, boa tarde.<br />
<br />Encerramos mais um período e apresentamos o nosso relatório com os andamentos processuais com seus casos.<br />
<br />Aproveitando a oportunidade, nos últimos meses, houve alguma alteração societária relevante para vocês?<br />
<br />O motivo da nossa pergunta é que, quando ocorre uma nova aquisição, uma cisão ou outro evento societário, além de termos que informar nos autos, podemos fazer uma avaliação de espelhamento das teses hoje em andamento.<br />
<br />Além da conformidade processual, isso garante uma equivalência entre as empresas do grupo, em termos de posicionamento. <br />
<br />Qualquer dúvida, estamos à disposição.<br />
<br />Abs,<br />${outputName}</p>`

	return `${defaultParagraph}<br />${getSignaturePlaceholder()}`
}

function getSignature(name, position, email, signatureTemplate) {
	return signatureTemplate
		.replace(/\[\[\[NAME\]\]\]/g, name)
		.replace(/\[\[\[POSITION\]\]\]/g, position)
		.replace(/\[\[\[EMAIL\]\]\]/g, email)
}

function removeSignature(content) {
	const regex = /<!-- signature -->([\S\s]*?)<!-- \/signature -->/
	return content.replace(regex, getSignaturePlaceholder())
}

function getSignaturePlaceholder() {
	return '[[[ASSINATURA]]]'
}
